import IconSettings from './IconSettings.js';
import './Settings.scss';

const SettingsButton = function(props) {
	return (
		<button className="button settings-button" onClick={props.clickHandler}><IconSettings /> {window?.t?.SETTINGS}</button>
	)
}

export default SettingsButton;